const lang = {
  code: 'ja',
  messages: {
    alpha: '{_field_}が正しくありません。',
    alpha_num: '{_field_}が正しくありません。',
    alpha_dash: '{_field_}が正しくありません。',
    alpha_spaces: '{_field_}が正しくありません。',
    between: '{_field_}が正しくありません。',
    confirmed: '{_field_}が一致しません。',
    digits: '{_field_}が正しくありません。',
    dimensions: '{_field_}が正しくありません。',
    email: '{_field_}が正しくありません。',
    excluded: '{_field_}が正しくありません。',
    ext: '{_field_}が正しくありません。',
    image: '{_field_}が正しくありません。',
    integer: '{_field_}が正しくありません。',
    is: '{_field_}が正しくありません。',
    length: '{_field_}が正しくありません。',
    max_value: '{_field_}が正しくありません。',
    max: '{_field_}が正しくありません。',
    mimes: '{_field_}が正しくありません。',
    min_value: '{_field_}が正しくありません。',
    min: '{_field_}が正しくありません。',
    numeric: '{_field_}が正しくありません。',
    oneOf: '{_field_}が正しくありません。',
    regex: '{_field_}が正しくありません。',
    required: '{_field_}は必須です。',
    required_input: '{_field_}が正しくありません。',
    required_if: '{_field_}が正しくありません。',
    size: '{_field_}が正しくありません。',
    half_size: '{_field_}が正しくありません。',
    full_half_size: '{_field_}が正しくありません。',
    postcode: '{_field_}が正しくありません。',
    validate_tel: '{_field_}が正しくありません。',
    mblength: '{_field_}が正しくありません。',
    with_under_score: '{_field_}が正しくありません。',
    after_date: '{_field_}が正しくありません。',
    before_date: '{_field_}が正しくありません。',
    check_ng_word: '{_field_}は使用できない文字が入っています。',
    validate_email: '{_field_}が正しくありません。',
    credit_card: '{_field_}が正しくありません。',
    credit_card_expiration: '{_field_}が正しくありません。',
    credit_card_security_code: '{_field_}が正しくありません。',
    post_code: '{_field_}が正しくありません。',
    phone_number: '{_field_}が正しくありません。',
    number_alphabet_character: '{_field_}は使用できない文字が入っています。',
    password_strong: '{_field_}が正しくありません。',
    same_value: '{_field_}が一致しません。',
  }
}

export default lang



// WEBPACK FOOTER //
// ./src/lang/ja/validation.js